import React, { useState, useEffect } from 'react';
import CardsOrganizational from '../components/CardsOrganizational'
import CardsBranches from '../components/CardsBranches'
import CardsManagers from '../components/CardsManagers'
import { Row, Col } from "react-bootstrap";
import Charts from '../components/Charts';
import RiskAnalysisTable from '../components/RiskAnalysisTable';
import DatePicker from "../components/DatePicker";
import BaseTablesingle from "../components/BaseTablesingle";
import Icon from '../components/Icon';
import Radio from "../components/Radio";
import Sort from '../components/Sort';
import SimpleSkeleton from "../skeletons/SimpleSkeleton";
import CardSkeleton from "../skeletons/CardSkeleton";
import BaseTable from "../components/BaseTable";
import MetricsConsideredModal from '../components/MetricsConsideredModal';
import OrganizationalMetricsModal from '../components/OrganizationalMetricsModal';
import { useOrganizationalMetricsModal } from '../hooks/useOrganizationalMetricsModal';
import { Tabs, Tab } from "react-bootstrap";
import { useMicrosoftAuth } from "../context/MicrosoftAuthContext";

import { fetchData, fetchDataPost, checkAccessToken } from "../services/apiService";
import { getPopupTableColumnName } from '../utils/commonUtils';

const Manager = ({ isOpen, toggle }) => {
    const { userTeamData } = useMicrosoftAuth();
    const startOfMonth = new Date(Date.UTC(new Date().getFullYear(), new Date().getMonth(), 1));
    const endOfMonth = new Date(Date.UTC(new Date().getFullYear(), new Date().getMonth() + 1, 0));
    const defaultStartDate = startOfMonth;
    const defaultEndDate = endOfMonth;

    const [dateRange, setDateRange] = useState([defaultStartDate, defaultEndDate]);
    const [startDate, endDate] = dateRange;

    const [allManagersData, setAllManagersData] = useState([]);
    const [allManagersDataLoading, setAllManagersDataLoading] = useState(false);

    const [objectives, setObjectives] = useState([]);
    const [objectivesCountLoading, setObjectivesCountLoading] = useState(true);

    const [greenMeticsCount, setGreenMeticsCount] = useState(0);
    const [yellowMeticsCount, setYellowMeticsCount] = useState(0);
    const [redMeticsCount, setRedMeticsCount] = useState(0);
    const [dateRangeData, setDateRangeData] = useState([]);
    const [metricsDateRangeData, setMetricsDateRangeData] = useState([]);
    const [metricBranchDataRangeData, setMetricBranchDataRangeData] = useState([]);
    const [metricManagersDataRangeData, setMetricManagersDataRangeData] = useState([]);
    const [metricAssistantsDataRangeData, setMetricAssistantsDataRangeData] = useState([]);
    const [metricPodsDataRangeData, setMetricPodsDataRangeData] = useState([]);

    const [organizationalEvaluationLoading, setOrganizationalEvaluationLoading] = useState(false);
    const [organizationalEvaluation, setOrganizationalEvaluation] = useState([]);

    const [metrics, setMetrics] = useState([]);
    const [activeObjectiveTab, setActiveObjectiveTab] = useState(0);
    const [activeObjectiveName, setActiveObjectiveName] = useState('');
    const [frequency, setFrequency] = useState('weekly');

    // Organization tabs (All Managers + individual manager items)
    const [activeOrganizationTab, setActiveOrganizationTab] = useState('all');
    const [activeOrganizationLabel, setActiveOrganizationLabel] = useState('All Managers');

    const organizationHeaders = ["Metric", "Baseline", "Target", "Result",  "Risk Level"];

    const [sortConfig, setSortConfig] = useState("name_asc");
    const [sortedData, setSortedData] = useState([]);

    const [showMetricsModal, setShowMetricsModal] = useState(false);
    const { modalState: orgMetricsModalState, handleMetricsCardClick: handleOrgMetricsCardClick, closeModal: closeOrgMetricsModal } = useOrganizationalMetricsModal();

    const [activeMetric, setActiveMetric] = useState({});

    const sortOptions = [
        { value: 'name_asc', label: 'Name (A→Z)' },
        { value: 'name_desc', label: 'Name (Z→A)' },
    ];

    const handleDateRangeChange = (newDateRange) => {
        // Create dates in UTC using Date.UTC()
        const startOfMonth = new Date(Date.UTC(newDateRange.startYear, newDateRange.startMonth - 1, 1));
        const endOfMonth = new Date(Date.UTC(newDateRange.endYear, newDateRange.endMonth, 0));
        newDateRange = [startOfMonth, endOfMonth];
        setDateRange(newDateRange);
        const [startDate, endDate] = newDateRange;
        if (startDate && endDate) {
            getOrganizationalEvaluation(activeObjectiveTab, startDate, endDate, frequency, activeOrganizationTab);
        }
    };

    async function getObjectives() {
        try {
            const result = await fetchData('getObjectives', controllerRef);

            const [startDate, endDate] = dateRange;
            if (result != null) {
                setObjectives(result);
                if (result.length > 0) {
                    setActiveObjectiveTab(result[0].id);
                    const activeObjective = result.find(objective => objective.id === result[0].id);
                    setActiveObjectiveName(activeObjective ? activeObjective.name : '');
                    getOrganizationalEvaluation(result[0].id, startDate, endDate, frequency, activeOrganizationTab);
                }
            }
        } catch (err) {
            console.log(err.message);
        } finally {
            setObjectivesCountLoading(true);
        }
    }

    async function getOrganizationalEvaluation(activeObjectiveTab, startDate, endDate, frequency = 'weekly', selectedOrganization = null, selectedManagerId = null) {
        setOrganizationalEvaluationLoading(true);
        try {
            var post_data = {};
            if (startDate) {
                post_data.startDate = startDate;
            }
            if (endDate) {
                var endDateWithAdjustedTime = new Date(endDate);
                endDateWithAdjustedTime.setUTCHours(23, 59, 59, 999);
                post_data.endDate = endDateWithAdjustedTime;
            }
            post_data.objectiveID = activeObjectiveTab;
            // keep organization as managers context for this page
            post_data.organization = "managers";
            post_data.frequency = frequency;
            post_data.user_team_id = userTeamData?.id;
            post_data.user_role_id = userTeamData?.user_role_id;
            if (selectedOrganization && selectedOrganization !== 'all') {
                // If a specific manager tab is selected we pass the manager id if available
                post_data.selectedOrganization = selectedOrganization;
            }
            if (selectedManagerId) {
                post_data.selectedManagerId = selectedManagerId;
            }
            var user_group = [];
            userTeamData?.user_group?.forEach(group => {
                user_group.push(group);
            });
            post_data.user_group = user_group;
            const result = await fetchDataPost('getOrganizationalEvaluation', post_data, controllerRef);
            console.log(result);
            if (result != null) {
                setMetrics(result.showMetrics);
                if(result.showMetrics.length>0){
                   setActiveMetric(result.showMetrics[0]);
                }
                setGreenMeticsCount(result.summary.greenMeticsCount??0);
                setYellowMeticsCount(result.summary.yellowMeticsCount??0);
                setRedMeticsCount(result.summary.redMeticsCount??0);
                setDateRangeData(result.dateRangeData);
                setMetricsDateRangeData(result.singleMetricsData);
                setMetricBranchDataRangeData(result.singleMetricBranchData);
                setMetricManagersDataRangeData(result.singleMetricManagersData || []);
                setMetricAssistantsDataRangeData(result.singleMetricAssistantData || []);
                setMetricPodsDataRangeData(result.singleMetricPodsData || []);
                
            }
            setOrganizationalEvaluationLoading(false);
        } catch (err) {
            console.log("err.message", err.message);
            // Don't set loading to false if request was cancelled
            if (err.name === 'AbortError' || err.message === 'canceled') {
                console.log('Request was cancelled');
            } else {
                console.log('Request failed with error');
                setOrganizationalEvaluationLoading(true);
            }
        } 
    }

    async function getManagersWithUsersCount() {
        setAllManagersDataLoading(true);
        try {
            var post_data = {};
            post_data.user_team_id = userTeamData?.id;
            post_data.user_role_id = userTeamData?.user_role_id;
            if(!userTeamData?.user_role_id.includes("10")){
                var user_group = [];
                userTeamData?.user_group?.forEach(group => {
                    user_group.push(group);
                });
                post_data.user_group = user_group;
            }
            const result = await fetchDataPost('getManagersWithUsersCount', post_data, controllerRef);
            if (result != null) {
                setAllManagersData(result);
            }
        } catch (err) {
            console.log(err.message);
        } finally {
            setAllManagersDataLoading(false);
        }
    }

    // Handle sort change from Sort component
    const handleSort = (field) => {
        setSortConfig(field);
    };
    
    // Sort and filter data when sort configuration, data, or search term changes
    useEffect(() => {
        if (allManagersData.length === 0) return;

        const sortableData = [...allManagersData];
        
        // Use all data without filtering
        const filteredData = sortableData;
        
        // Sort the filtered data
        filteredData.sort((a, b) => {
            const [field, direction] = sortConfig.split('_');
            if (typeof a[field] === 'number') {
                return direction === 'asc' 
                    ? a[field] - b[field]
                    : b[field] - a[field];
            } else {
                const valueA = String(a[field]).toLowerCase();
                const valueB = String(b[field]).toLowerCase();
                if (direction === 'asc') {
                    return valueA.localeCompare(valueB);
                } else {
                    return valueB.localeCompare(valueA);
                }
            }
        });
        
        setSortedData(filteredData);
    }, [sortConfig, allManagersData]);
    

    var controllerRef = new AbortController();

    // Metric card click handlers (simple handlers that can be extended)
    const handleMetricsCardClick = () => setShowMetricsModal(true);

    const handleOrganizationalMetricsCardClick = (cardType) => {
        handleOrgMetricsCardClick(cardType, {
            date: startDate || new Date(),
            title: activeObjectiveName
        });
    };

    const handleOrganizationTabClick = (org) => {
        setActiveOrganizationTab(org.organizationsName);
        setActiveOrganizationLabel(org.organizationsLabel);
        // If managerId is present, include it
        const [sDate, eDate] = dateRange;
        getOrganizationalEvaluation(activeObjectiveTab, sDate, eDate, frequency, org.organizationsName, org.managerId);
    };

    // Handle objective tab change from Bootstrap Tabs
    useEffect(() => {
        // whenever objective changes, refresh organizational evaluation
    }, [activeObjectiveTab, activeOrganizationTab]);

    // Generate organizations list for the tabs
    const organizations = [
        { organizationsName: 'all', organizationsLabel: 'All Managers' },
        ...allManagersData.map(item => ({ organizationsName: `manager-${item.userID}`, organizationsLabel: item.name, managerId: item.userID }))
    ];

    var controllerRefLocal = controllerRef; // keep previous variable name usage intact
    const loadData = async () => {
        await checkAccessToken(controllerRefLocal);
        getManagersWithUsersCount();
        getObjectives();
    }

    useEffect(() => {
        loadData();
    }, []);
    return (
        <div className='bg-white p-30-19'>
            <div className='p-24 rounded-16 app-shadow-sm bg-white mb-24'>
                <div className='d-flex align-items-center justify-content-between mb-24'>
                    <div className='fw-600 text-24 text-black '>All Managers Detail</div>
                </div>
                <Row>
                    {!allManagersDataLoading ?
                        sortedData.map((item, index) => (
                            <Col key={index} sm={12} md={6} lg={4} xl={4} className='mt-24'>
                                <CardsManagers
                                    CardLabel={item.name}
                                    phone={item.phone}
                                    email={item.email}
                                    PageRoute={"/manager/singlemanager/" + item.userID}
                                />
                            </Col>
                        ))
                        :
                        <CardSkeleton rows={4} columns={4} />
                    }
                </Row>
            </div>

            {/* Analytics section - match Branches layout/Figma */}
            <div className='organizational-analytics-container mb-24'>
                <div className='organizational-analytics-title'>All Managers Analytics</div>

                <div className='analytics-controls-container'>
                    <div className='analytics-section'>
                        <div className='objective-controls'>
                            <div className='objective-label'>Select Objective:</div>
                            {objectives.map((item) => (
                                <button
                                    key={`${item.id}`}
                                    className={`objective-tab ${activeObjectiveTab == item.id ? 'active' : ''}`}
                                    onClick={() => {
                                        const [sDate, eDate] = dateRange;
                                        setActiveObjectiveTab(item.id);
                                        const obj = objectives.find(objective => objective.id == item.id);
                                        setActiveObjectiveName(obj ? obj.name : 'NA');
                                        getOrganizationalEvaluation(item.id, sDate, eDate, frequency, activeOrganizationTab);
                                    }}
                                >
                                    {item.name}
                                </button>
                            ))}
                        </div>

                        <div className='date-range-controls'>
                            <div className='date-picker-container'>
                                <DatePicker views={['year', 'month']} openTo="month" datetitle={'text-12 fw-500 text-4E4E4E'} datepicker={"bg-black text-white"} icon={"calendar-dark"} startDate={startDate} endDate={endDate} handleDateRangeChange={handleDateRangeChange} />
                            </div>
                        </div>
                    </div>

                    <div className='metrics-cards-container'>
                        <CardsOrganizational
                            isMetricsCard={true}
                            totalCount={metrics.length}
                            CardLabel="Metrics Considered"
                            onMetricsCardClick={handleMetricsCardClick}
                            isLoading={organizationalEvaluationLoading}
                        />
                        <CardsOrganizational
                            isMetricsCard={true}
                            metricsCardType="green"
                            totalCount={greenMeticsCount}
                            CardLabel="Green Level"
                            onDetailsClick={handleOrganizationalMetricsCardClick}
                            isLoading={organizationalEvaluationLoading}
                        />
                        <CardsOrganizational
                            isMetricsCard={true}
                            metricsCardType="amber"
                            totalCount={yellowMeticsCount}
                            CardLabel="Amber Level"
                            onDetailsClick={handleOrganizationalMetricsCardClick}
                            isLoading={organizationalEvaluationLoading}
                        />
                        <CardsOrganizational
                            isMetricsCard={true}
                            metricsCardType="red"
                            totalCount={redMeticsCount}
                            CardLabel="Red Level"
                            onDetailsClick={handleOrganizationalMetricsCardClick}
                            isLoading={organizationalEvaluationLoading}
                        />
                    </div>
                </div>
            </div>

            <div className='risk-analysis-group'>
                <Charts
                    objectiveName={activeObjectiveName}
                    allMetric={metrics}
                    metricsCount={metrics.length}
                    objectivesCount={objectives.length}
                    greenMeticsCount={greenMeticsCount}
                    yellowMeticsCount={yellowMeticsCount}
                    redMeticsCount={redMeticsCount}
                    dateRangeData={dateRangeData}
                    isDataLoading={organizationalEvaluationLoading}
                    activeMetric={activeMetric}
                    dateRange={dateRange}
                    onMetricChange={(metric) => setActiveMetric(metric)}
                    onDataChange={(data) => setActiveMetric(
                        (Array.isArray(data) ? data : []).map(item => ({
                            date: item.date,
                            target: item.target,
                            result: item.result,
                            riskLevel: item.risk
                        }))
                    )}
                    onFrequencyChange={(newFrequency) => {
                        setFrequency(newFrequency);
                        const [sDate, eDate] = dateRange;
                        getOrganizationalEvaluation(activeObjectiveTab, sDate, eDate, newFrequency, activeOrganizationTab);
                    }}
                />

                <RiskAnalysisTable
                    isDataLoading={organizationalEvaluationLoading}
                    dateRangeData={dateRangeData}
                    activeMetric={activeMetric}
                    metricBranchDataRangeData={metricManagersDataRangeData}
                    dateRange={dateRange}
                    date={startDate && endDate ?
                        `${startDate.getMonth() + 1}/${startDate.getFullYear()} → ${endDate.getMonth() + 1}/${endDate.getFullYear()}` :
                        ''
                    }
                    columnName={getPopupTableColumnName('managers')}
                />
            </div>

          
            {/* Metrics Considered Modal */}
            <MetricsConsideredModal
                show={showMetricsModal}
                onHide={() => setShowMetricsModal(false)}
                objective={activeObjectiveName}
                metricsDateRangeData={metricsDateRangeData}
                isDataLoading={organizationalEvaluationLoading}
                date={startDate && endDate ?
                    `${startDate.getMonth() + 1}/${startDate.getFullYear()} → ${endDate.getMonth() + 1}/${endDate.getFullYear()}` :
                    ''
                }
            />

            {/* Organizational Metrics Modal */}
            <OrganizationalMetricsModal
                show={orgMetricsModalState.show}
                onHide={closeOrgMetricsModal}
                data={metricsDateRangeData}
                title={orgMetricsModalState.title}
                cardType={orgMetricsModalState.cardType}
                date={startDate && endDate ?
                    `${startDate.getMonth() + 1}/${startDate.getFullYear()} → ${endDate.getMonth() + 1}/${endDate.getFullYear()}` :
                    ''
                }
            />
        </div>
    );
};

export default Manager;
